import { Component, Input, ViewEncapsulation } from '@angular/core';
import { LoadingIndicatorService } from '../../../core/services/loading-indicator.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoadingIndicatorComponent {
  @Input() loadingMessage: string;

  @Input() leftMargin = '0';
  @Input() rightMargin = '0';
  @Input() bottomMargin = '80px';
  @Input() backgroundColor = '#333';

  public showFetch: boolean;

  constructor(service: LoadingIndicatorService, private router: Router) {
    service.showFetchDataLoading$.subscribe(showFetch => {
      this.showFetch = showFetch;
    });
  }
}
